import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageContainer from '../Global/Containers/PageContainer';
import TrendingSearches from '../Search/TrendingSearches';
import LargeSearch from '../Search/LargeSearch';
import MaxWidthContainer from '../Global/Containers/MaxWidthContainer';
import staticUrl from "../../utils/staticPath";

class FourOFourPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: ``,
      searchLoading: false,
    };
  }

  onSearchTermChangeHandler = (e) => {
    this.setState({ searchTerm: e.target.value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    this.setState({ searchLoading: true });
    window.location.href = `/search?term=${this.state.searchTerm}`;
  }

  render() {
    const { results } = this.props.trendingSearches;
    const { searchTerm, searchLoading } = this.state;
    const fourZeroFourImage = `${staticUrl()}assets/images/raster/error-404-with-ball.jpg`
    return (
      <PageContainer classes="bg-white">
        <div className="bg-grey--bg text-center p-t-7 p-b-7">
          <MaxWidthContainer>
            <div className="max-width-s m-x-auto">
              <img className="max-width-xs m-b-7" src={fourZeroFourImage} alt="Error 404, displays the number 0 as a football" />
              <LargeSearch searchTerm={searchTerm} searchLoading={searchLoading} onSearchTermChange={this.onSearchTermChangeHandler} onSearchSubmit={this.handleSearchSubmit} />
            </div>
          </MaxWidthContainer>
        </div>
        <div className="bg-white text-center p-t-2">
          <MaxWidthContainer>
            <div className="horizontal-center-inner text-left p-t-2">
              <div className="m-b-4">
                {results && results.length > 0 &&
                  <TrendingSearches results={results} titleClasses="like-h5 m-b-0"  />
                }
              </div>
              <div className="m-b-4">
                <h2 className="like-h5 m-b-0 horizontal-center-inner">Get in touch:&nbsp;</h2>
                <a href="mailto:help@thecoachingmanual.com?Subject=Help from 'Error 404' page" className="link">help@thecoachingmanual.com</a>
              </div>
              <a href="/" className="btn btn--l m-t-2">Back to Home Page</a>
            </div>
          </MaxWidthContainer>
        </div>
      </PageContainer>
    );
  }
}

FourOFourPage.propTypes = {
  trendingSearches: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    trendingSearches: state.search.trendingSearches,
  };
}

export default connect(mapStateToProps)(FourOFourPage);


// WEBPACK FOOTER //
// ./library/app/components/Errors/FourOFourPage.js